import {
  CONVERSION_FEE_PERCENT,
  formatCurrencyAmount,
  formatFxRate,
  formatPercent,
  getConversionQuote,
  getCurrency,
} from "../constants";

export const ContaInternacionalConverterSummary = ({
  fromId,
  toId,
  amount = 0,
  className = "",
}) => {
  if (!fromId || !toId) return null;

  const numericAmount =
    typeof amount === "number"
      ? amount
      : parseFloat(String(amount).replace(",", ".")) || 0;

  const fromCurrency = getCurrency(fromId);
  const toCurrency = getCurrency(toId);
  const quote = getConversionQuote(fromId, toId, numericAmount);

  return (
    <section
      className={`rounded-xl border border-gray-100 bg-gray-50/50 p-3 ${className}`.trim()}
    >
      <h3 className="text-sm font-bold text-brand-dark">Resumo da conversão</h3>
      <p className="mt-0.5 text-xs text-gray-500">
        Estimativa com cotação de mercado e taxa de {formatPercent(CONVERSION_FEE_PERCENT)}
      </p>

      <div className="mt-3 space-y-2">
        <div className="rounded-xl bg-white px-3 py-2">
          <p className="text-xs text-gray-500">Cotação</p>
          <p className="mt-0.5 text-base font-bold text-brand-dark">
            1 {fromCurrency?.code} = {formatFxRate(quote.rate)} {toCurrency?.code}
          </p>
        </div>

        <div className="space-y-1.5 text-sm">
          <div className="flex justify-between gap-3">
            <span className="text-gray-500">Origem</span>
            <span className="text-right font-semibold text-brand-dark">
              {quote.hasAmount
                ? formatCurrencyAmount(numericAmount, fromId)
                : "—"}
            </span>
          </div>
          <div className="flex justify-between gap-3">
            <span className="text-gray-500">Destino (estimado)</span>
            <span className="text-right font-semibold text-brand-dark">
              {quote.hasAmount
                ? formatCurrencyAmount(quote.grossReceive, toId)
                : "—"}
            </span>
          </div>
          <div className="flex justify-between gap-3">
            <span className="text-gray-500">
              Taxa de serviço ({formatPercent(quote.feePercent)})
            </span>
            <span className="text-right font-semibold text-brand-dark">
              {quote.hasAmount
                ? formatCurrencyAmount(quote.fee, toId)
                : "—"}
            </span>
          </div>
          {quote.iofApplies && (
            <div className="flex justify-between gap-3">
              <span className="text-gray-500">IOF ({formatPercent(quote.iofPercent)})</span>
              <span className="text-right font-semibold text-brand-dark">
                {quote.hasAmount
                  ? formatCurrencyAmount(quote.iof, "brl")
                  : "—"}
              </span>
            </div>
          )}
          <div className="flex justify-between gap-3 border-t border-gray-100 pt-1.5">
            <span className="font-semibold text-brand-dark">Valor líquido a receber</span>
            <span className="text-right text-base font-bold text-[#e7a73f]">
              {quote.hasAmount
                ? formatCurrencyAmount(quote.netReceive, toId)
                : "—"}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
